export default __webpack_public_path__ + "static/media/gallery-wip-denix-scope-mount-hole_02.5fcdd4db.jpg";